import useQuery from 'hooks/useQuery'

import { ChildrenContainer } from '../../components/Layout/Page'
import VetDecPage from '../VetDeclaration/VetDecPage'
import {
  TrackingCodePanel,
  DownloadPdf,
  InfoPanel,
  SendPdfEmail,
} from './ReceiptComponents'

import config from '../../config'

export default function DeclarationSubmitted() {
  const { trackingCode, submissionId } = useQuery()

  const formId = config.VET_DEC_FORM_ID

  return (
    <VetDecPage>
      <ChildrenContainer className="fa-form-receipt">
        <TrackingCodePanel trackingCode={trackingCode as string} />
        <InfoPanel>
          <p>
            The veterinarian declaration is now complete and the Record of
            Movement form has been successfully submitted.
          </p>
          <br />
          <p>
            A copy of this form has been sent to your email address and the
            stock owner's, with a printable summary report.
          </p>
        </InfoPanel>
        <DownloadPdf
          trackingCode={trackingCode as string}
          submissionId={submissionId as string}
          formId={formId}
        />
        <SendPdfEmail submissionId={submissionId as string} formId={formId} />
        <InfoPanel className="fa-info-panel">
          <span>
            For any queries please contact 02 6626 1201, or email{' '}
            <a href="mailto:cattletick@dpi.nsw.gov.au">
              cattletick@dpi.nsw.gov.au
            </a>{' '}
            and quote your reference code.
          </span>
        </InfoPanel>
      </ChildrenContainer>
    </VetDecPage>
  )
}
